<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-form
            :model="searchData"
            label-width="90px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="角色：">
                  <el-select v-model="searchData['role_id']">
                    <el-option
                      v-for="item in RoleData"
                      :value="item.value"
                      :label="item.label"
                      :key="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专业度：">
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['professionalDegrees1']"
                    dict-type="student"
                    name="score"/>
                  <em>到</em>
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['professionalDegrees2']"
                    dict-type="student"
                    name="score"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="响应时间：">
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['responseTime1']"
                    dict-type="student"
                    name="score"/>
                  <em>到</em>
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['responseTime2']"
                    dict-type="student"
                    name="score"/>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="服务态度：">
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['serviceAttitude1']"
                    dict-type="student"
                    name="score"/>
                  <em>到</em>
                  <jm-dict-select
                    class="jm-input90"
                    clearable
                    type="dataset"
                    v-model="searchData['serviceAttitude2']"
                    dict-type="student"
                    name="score"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="basic-padding jm-tac">
                  <el-button
                    class="jm-input-common3"
                    type="primary"
                    @click="() => this.refresh = true">搜索</el-button>
                  <el-button
                    class="jm-input-common3"
                    type="default"
                    @click="resetFields">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <jm-tableList
            url="/index/Statistics/getPraiseList"
            :search-data="searchData"
            :refresh.sync="refresh">
            <el-table-column
              slot="count"
              label="评价数">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'evaluationList', params: { teacherid: scope.row.teacherid } }">
                  {{ scope.row.count }}
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect, } from '@/components/tool/index.js';

export default {
  data() {
    return {
      searchData: {
        role_id: '',
        startSchoolDateYear: '',
        startSchoolDateMonth: '',
        signingTime: '',
        responseTime1: '',
        responseTime2: '',
        serviceAttitude1: '',
        serviceAttitude2: '',
        professionalDegrees1: '',
        professionalDegrees2: ''
      },
      RoleData: '', // 角色数据字典
      refresh: false,
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  computed: {
  },
  methods: {
    /**
     * Description: 读取角色数据字典
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getRole() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/Statistics/getPraiseRole',
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * Description: 重置搜索条件
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = null;
      });
    },
  },
  mounted() {
    this.getRole().then((data) => {
      this.RoleData = data.role_id;
    });
  },
  watch: {
  },
};
</script>
<style scoped>
  .basic-padding {
    padding: 20px 10px;
    text-align: left;
  }
</style>
